<template>
	<GbGuideArticle nav-page="blogs">
		<h1><strong>GB WhatsApp Advanced Settings Guide</strong></h1>
		<p>So, you have mastered the basics and you are ready for more? Welcome to the pro league. <strong>GB WhatsApp</strong> is famous for its massive library of hidden features and deep customization options.</p>
		<p>While regular users stick to changing wallpapers, power users dive into the <strong>GB WhatsApp mod</strong> to automate replies, schedule messages, and completely overhaul the user interface.</p>
		<p>This guide will walk you through the most powerful tools hidden in the menus. If you ever get lost or want to start over, you can always head back to the <a href="/">GB WhatsApp</a> home page for basic tutorials.</p>

		<h2><strong>Overview of Advanced Settings</strong></h2>
		<p>To access the pro features, tap the three dots in the top right corner and open <strong>GB WhatsApp</strong> settings. This menu is entirely separate from the standard WhatsApp settings.</p>
		<ul>
			<li><strong>Themes:</strong> Download thousands of custom themes created by the community.</li>
			<li><strong>Universal:</strong> Change core app colors, fonts, and emoji variants (like iOS emojis).</li>
			<li><strong>Home Screen:</strong> Customize the layout of your main chat list, status tabs, and floating action buttons.</li>
			<li><strong>Chat Screen:</strong> Tweak the look of individual conversation windows, bubbles, and ticks.</li>
		</ul>

		<h2><strong>Notification Controls</strong></h2>
		<p>Tired of the same old "ding" sound? The <strong>GB WhatsApp app</strong> gives you granular control over how and when you are notified.</p>
		<ol>
			<li><strong>Online Toast:</strong> Get a small pop-up notification at the top or bottom of your screen whenever a specific contact comes online.</li>
			<li><strong>Profile Pic Toast:</strong> Get notified when a contact changes their profile picture.</li>
			<li><strong>Disable Heads-up:</strong> Stop message previews from dropping down over your screen while you are playing games or watching videos.</li>
			<li><strong>Custom Icons:</strong> Change the color of the notification icon that appears in your phone's status bar.</li>
		</ol>

		<h2><strong>Privacy Customization</strong></h2>
		<p>We covered basic privacy before, but the advanced <strong>GB WhatsApp settings</strong> take stealth to the absolute maximum.</p>
		<ul>
			<li><strong>Custom Privacy Per Contact:</strong> Tap on any friend's name in their chat. You can hide blue ticks, hide typing, and hide recording for that specific person without affecting anyone else.</li>
			<li><strong>Anti-Delete Status:</strong> Not only can you view deleted statuses, but you can also download them directly to your phone using the built-in download button.</li>
			<li><strong>Show Blue Ticks After Reply:</strong> This is the ultimate power move. The sender will only see the blue ticks after you have typed and sent your reply, giving you unlimited time to think of an answer.</li>
		</ul>

		<h2><strong>Chat Behavior Settings</strong></h2>
		<p>Make your chatting experience faster and smarter with these behavioral tweaks.</p>
		<ul>
			<li><strong>Message Scheduler:</strong> Need to wish someone a happy birthday at midnight? Use the Message Scheduler to type your message now and have the app send it automatically later.</li>
			<li><strong>Auto Reply:</strong> Set up a bot to reply to incoming messages when you are busy. You can customize the reply text and choose whether it responds to everyone or just specific contacts.</li>
			<li><strong>Mass Message Sender:</strong> Broadcast a single message to multiple contacts or groups simultaneously. Use this feature carefully to avoid spamming.</li>
		</ul>

		<h2><strong>Media Control Options</strong></h2>
		<p>The official app ruins photo quality. <strong>GB WhatsApp</strong> fixes this completely.</p>
		<ol>
			<li>Go to GB Settings > Universal > Settings.</li>
			<li><strong>Send Images in Full Resolution:</strong> Slide the bar to the maximum (up to 3MB or more) to send uncompressed, crystal-clear photos.</li>
			<li><strong>Increase Video Limit:</strong> Bypass the standard 16MB limit and send large video files directly through the chat.</li>
			<li><strong>Disable Media Share Limit:</strong> Send more than 30 images at once. You can select up to 90 images in a single batch.</li>
		</ol>

		<h2><strong>Power User Tips</strong></h2>
		<p>To truly master the app, keep these final pro tips in mind:</p>
		<ul>
			<li><strong>Backup Before Theming:</strong> Applying a new theme changes hundreds of UI elements. Always create a local backup before trying a new theme, just in case you do not like the result.</li>
			<li><strong>Use DND Mode:</strong> Tap the Wi-Fi icon on the home screen to enable Do Not Disturb mode. This cuts off the internet only for the app, letting you read old messages in complete peace.</li>
			<li><strong>Clear Logs:</strong> Advanced features generate cache files. Go to GB Settings and use the built-in cleaner to wipe logs and keep the app running fast.</li>
			<li><strong>Stay Updated:</strong> Mod features rely on exploiting the official app's code. Always keep your app updated to the latest version to ensure these advanced features keep working smoothly.</li>
		</ul>
		<p>You are now officially a power user. Enjoy customizing your app exactly the way you want it!</p>
	</GbGuideArticle>
</template>

<script>
import GbGuideArticle from '@/components/GbGuideArticle.vue';

export default {
	name: 'GuideAdvancedSettings',
	components: { GbGuideArticle },
};
</script>
